import { OUTLIER_COLUMNS, OUTLIER_FILTERS } from '@features/admin/outliers/outliersProtos';
import { useOutlierActionsColumns } from '@features/admin/outliers/useOutlierActionsColumns';
import { useAdminApi } from '@hooks/useAdminApi';
import { BlotterWidget } from '@shared/components/BlotterWidget';
import { usePageTitle } from '@shared/hooks/usePageTitle';
import { ColDef } from 'ag-grid-enterprise';
import { useCallback } from 'react';
import { NavigateFunction, useNavigate, useSearchParams } from 'react-router-dom';

const getRowId = ({ data }): string => data?.id?.toString();

const defaultColDef = (navigate: NavigateFunction, period: string, status: string) => {
  return {
    sortable: true,
    filter: false,
    floatingFilter: false,
    resizable: true,
    width: 150,
    onCellClicked(event) {
      if (event.column.getColId() === 'symbol') {
        navigate(`/admin/outliers/${event.data.symbol}?period=${period}&status=${status}`);
      }
    },
    cellStyle(params) {
      if (params.column.getColId() === 'symbol') {
        return { cursor: 'pointer' };
      }
      return null;
    },
  } as ColDef;
};

export const OutliersAdminPage = () => {
  usePageTitle('Outliers - Admin');
  const navigate = useNavigate();
  const { apiClient } = useAdminApi();
  const [searchParams] = useSearchParams();
  const period = searchParams.get('period') || '1m';
  const status = searchParams.get('status') || 'open';

  const dataLoader = apiClient?.outliersLoader();
  const COLUMNS = useOutlierActionsColumns(OUTLIER_COLUMNS);

  const filtersTransformer = useCallback((urlParamFilters: { [x: string]: any }) => {
    const defaultFilters = {
      status: 'open',
      period: '1m',
      ...urlParamFilters,
    };
    return defaultFilters;
  }, []);

  if (!dataLoader) return null;

  return (
    <BlotterWidget
      dataLoader={dataLoader}
      columnDefs={COLUMNS}
      filters={OUTLIER_FILTERS}
      getRowId={getRowId}
      defaultColDef={defaultColDef(navigate, period, status)}
      filtersTransformer={filtersTransformer}
      setInitialURL={true}
    />
  );
};
